import React from 'react'
import Home from './component/Home'
import About from './component/About'
import Services from './component/Services'
import ContactUs from './component/ContactUs'
import Blog from './component/Blog'
import DigitalMarketing from './component/DigitalMarketing'
import Sco from './component/Sco'
import GraphicDesign from './component/GraphicDesign'


import { BrowserRouter, Route, Routes} from 'react-router-dom';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
       <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About/>}/>
        <Route path="/services" element={<Services/>}/>
        <Route path="/contactus" element={<ContactUs/>}/>
        <Route path="/blog" element={<Blog/>}/>
        <Route path="/digitalmarketing" element={<DigitalMarketing/>}/>
        <Route path="/sco" element={<Sco/>}/>
        <Route path="/graphicdesign" element={<GraphicDesign/>}/>
       </Routes>
    </BrowserRouter>
  )
}

export default App